// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');

// @components
const RANonresidentialModal = require('../../components/RANonresidentialModal/RANonresidentialModal');

// @utilities
const { formatText } = require('core/i18n').i18n;

class RAFeatureFlagModal extends React.Component {
    render() {
        const {
            immRAFeatureFlag,
            featureModalToggle,
            redirectionLink,
            immGlobalVariables,
        } = this.props;
        const title = formatText('raNonresidentialModal-titleRoboHired');
        const message = formatText(
            'raNonresidentialModal-descriptionRoboHired',
        );
        const buttonText = formatText('raNonresidentialModal-button');
        const investPhone =
            !!immGlobalVariables && !!immGlobalVariables.get('telefono')
                ? immGlobalVariables.getIn(['telefono', 'inversiones'])
                : '';

        return (
            <RANonresidentialModal
                showModal={immRAFeatureFlag.get('isFeatureModalOpen')}
                title={title}
                closeModal={featureModalToggle}
                message={message}
                button={buttonText}
                number={investPhone}
                redirectionLink={redirectionLink}
            />
        );
    }
}

RAFeatureFlagModal.propTypes = {
    immRAFeatureFlag: PropTypes.object,
    featureModalToggle: PropTypes.func,
    redirectionLink: PropTypes.string,
    immGlobalVariables: PropTypes.object,
};

module.exports = connect(state => ({
    immGlobalVariables: state.globalVariables.getIn([
        'variables',
        'parameters',
    ]),
}))(RAFeatureFlagModal);
